import { General } from "../../siteManagement/general";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { TargetEntityType } from "./reportMetaData";
import { Grid } from "../core/components/grid";
import { Helper } from "../core/util/helper";
import { SheetEventType, Sheet } from "../../siteManagement/sheet";
import { Config } from "../core/config/config";
import { FAIcon } from "../core/components/faIcon";
import { FullHeightContainer } from "../core/components/FullHeighContainer";
import { ComponentHelper } from "../core/util/componentHelper";
import { TextBox } from "../core/components/textBox";
import { DropDownList } from "../core/components/dropDownList";
import { MultiSelect } from "../core/components/multiSelect";
import { Drawer } from "../../siteManagement/drawer";
import { StringKeyDictionary } from "../commonInterfaces";
import React from "react";
import ReactDOM from "react-dom";

export default class SearchGrid extends React.Component<any, SearchGridState> {
    private leftDrawerRef: JQuery<HTMLElement>;
    private gridOptions: kendo.ui.GridOptions;
    private translations: StringKeyDictionary<string>;
    private factory = ComponentHelper.createFactory();
    private sheet: Sheet;
    private dataSource: any[] = [];
    private drawer: Drawer;

    constructor(props) {
        super(props);
        this.state = {
            Name: null,
            TargetEntityType: null,
            gridData: [],
            SearchMode: [SearchMode.Active, SearchMode.Draft]
        }
        this.sheet = General.Sheet.Manager.getTopMostSheet();
        this.drawer = General.Drawer.Left;
        this.leftDrawerRef = this.sheet.elements.getLeftDrawerElementRef();
        this.initApp();
        this.setEvents();
    }

    private setEvents = () => {
        $(document).keydown(this.onKeyDown)
        this.sheet.bind(SheetEventType.Custom, (data: { cmd: string }) => {
            switch (data.cmd) {
                case "reloadReportInfo":
                    General.Functions.HistoryState.replaceState("ReportMetaData/SearchReport");
                    this.loadData();
                    break;
            }
        });
    }

    private initApp = async () => {     
        General.Functions.HistoryState.replaceState("ReportMetaData/SearchReport");
        const keys = [
            "Standard.Key",
            "Standard.Name",
            "Field.Adresse.iaktiv",
            "WebSMS.ReportMetadata.TargetEntityType",
            "Field.fstasks.state",
            "WebSMS.Report.Question.Search.NotReleased",
            "WebSMS.Report.Question.Search.Released",
            "Standard.Editable",
            "Standard.Aktiviert",
            "Standard.Deaktiviert"
        ];
        const [translations, dataSource, _] = await Promise.all([
            Helper.getTranslations(keys),
            HTTPService.get("ReportMetaData/GetSearchModes"),
            this.loadData()
        ]);
        this.dataSource = dataSource;
        this.translations = translations.Data;
        this.setGridOptions();
        this.setState({}, this.addAdditionalOnClickEvents);

        
    }

    private addAdditionalOnClickEvents = () => {
        const classes = ["k-grid-header", "k-pager-wrap k-grid-pager k-widget k-floatwrap"];
        classes.forEach((value) => {
            const ls = document.getElementsByClassName(value);
            if (ls.length > 0) {
                const el = (ls[0] as HTMLElement);
                el.onclick = () => {
                    this.buildLinks();
                }
            }
        });
    }

    private onKeyDown = (e: JQuery.KeyDownEvent) => {
        if (General.Sheet.Manager.getTopMostSheet().id() === this.sheet.id() && !Helper.isDialogOpen()) {
            const enter = 13;
            const keyCode = e.keyCode;
            switch (keyCode) {
                case enter:
                    this.loadData();
                    break;
            }
        }
    }

    private setGridOptions = () => {
        this.gridOptions = {
            sortable: true,
            pageable: true,
            groupable: false,
            filterable: false,
            selectable: true,
            resizable: true,
            scrollable: true,
            columns: [
                {
                    field: "Name",
                    title: this.translations["Standard.Name"],
                    template: `<a title='#= 'ReportMetaData/Edit?id=' + data.Id #' id='#= 'reportSearchGrid_' + data.Id#'>#=data.Name#</a>`
                },
                {
                    field: "TargetEntityTypeName",
                    title: this.translations["WebSMS.ReportMetadata.TargetEntityType"]
                },
                {
                    field: "State",
                    title: this.translations["Field.fstasks.state"],
                    template: `# if(data.State == 1) {# 
                        <div class='grid-icon-custom-center' style='color:green' title='${this.translations["Standard.Aktiviert"]}'>
                            <i class="fal fa-thumbs-up"></i>
                        </div> 
                    #} else if(data.State == 0){#
                        <div class='grid-icon-custom-center' style='color:red' title='${this.translations["Standard.Deaktiviert"]}'>
                            <i class="fal fa-thumbs-down"></i>
                        </div> 
                    #} else {#
                        <div class='grid-icon-custom-center' title='${this.translations["Standard.Editable"]}'>
                            <i class='fal fa-edit'></i>
                        </div>#
                    }#`
                }
            ]
        };
    }

    private loadData = async () => {
        let filter: SearchFilter = {
            Name: this.state.Name,
            TargetEntityType: this.state.TargetEntityType,
            SearchMode: this.state.SearchMode
        }

        const result = await HTTPService.post<JsonResultClass>("ReportMetaData/GetSearchResult", filter);
        if (result.Code === 0)
            this.setState({ gridData: result.Data })
    }

    private createSearchFilter = () => {
        let filter: JSX.Element = (
            <FullHeightContainer style={{ padding: "10px" }}>
                <button className="k-button" onClick={this.loadData} style={{ backgroundColor: "var( --primary-color)", color: "white", border: "none", height: "36px", borderRadius: "var(--border-radius)", fontSize: "16px" }}>
                    {Helper.getTranslation("Standard.Suche")}
                </button>
                {this.createNameTextBox()}
                {this.createEntityTypeDropDown()}
                {this.createSerachModeMultiselect()}
            </FullHeightContainer>
        );
        return ReactDOM.createPortal(filter, this.leftDrawerRef[0]);
    }

    private createNameTextBox = () => {
        let props = this.factory.getDefaultTextBoxProps();
        props.value = Helper.getValueOrDefault(this.state.Name, "");
        props.field.triggerOnChange = true;
        props.onChange = (field, value: string) => {
            this.setState({ Name: value });
        }
        return this.createSearchElement(<><TextBox {...props} /></>, this.translations["Standard.Name"]);
    }

    private createEntityTypeDropDown = () => {
        let props = this.factory.getDefaultDropDownProps();
        props.value = this.state.TargetEntityType;
        props.field.dataTextField = "Value";
        props.field.dataValueField = "Key";
        props.field.dataSourceUrl = "ReportMetaData/GetEntityTypes";
        props.onChange = (_, value) => {
            this.setState({ TargetEntityType: value });
        }
        return this.createSearchElement(<><DropDownList {...props} /></>, this.translations["WebSMS.ReportMetadata.TargetEntityType"]);
    }

    //private createSearchModeDropDown = () => {
    //    let props = this.factory.getDefaultDropDownProps();
    //    props.value = this.state.SearchMode;
    //    props.field.dataTextField = "Value";
    //    props.field.dataValueField = "Key";
    //    props.field.dataSourceUrl = "ReportMetaData/GetSearchModes";
    //    props.field.optionLabel = "";
    //    props.onChange = (field, value) => {
    //        this.setState({ SearchMode: value });
    //    }
    //    return this.createSearchElement(<><DropDownList {...props} /></>, this.translations["Field.fstasks.state"]);
    //}

    private createSerachModeMultiselect = () => {
        const props = this.factory.getDefaultMultiSelectProps();
        props.value = this.dataSource.filter(item => this.state.SearchMode.findIndex(sm => sm == item.Key) != -1);//   this.state.SearchMode;
        props.field.dataTextField = "Value";
        props.field.dataValueField = "Key";
        props.dataSource = this.dataSource;
        props.onChange = (_, value) => {
            this.setState({ SearchMode: value.map(item => item.Key) });
        }
        return this.createSearchElement(<><MultiSelect {...props} /></>, this.translations["Field.fstasks.state"]);
    }

    private createSearchElement = (element: JSX.Element, label: string) => {
        return (
            <div style={{ margin: "5px 0" }}>
                <label>{label}</label>
                {element}
            </div>
            );
    }

    private createGrid = () => {
        return (
            <div className="flex-container">
                <Grid
                    data={this.state.gridData}
                    options={this.gridOptions}
                    id="searchReportGrid"
                
                />
            </div>
        );
    }

    componentDidUpdate() {
        this.buildLinks();
    }

    private buildLinks = () => {
        for (let i = 0; i < this.state.gridData.length; i++) {
            let el = document.getElementById("reportSearchGrid_" + this.state.gridData[i].Id.toString())
            if (Helper.hasValue(el)) {
                const url = Config.baseUrl + "ReportMetaData/Edit?id=" + this.state.gridData[i].Id;
                el.onclick = () => {
                    this.createSheet(url)
                };
                el.onauxclick = (e) => {
                    if (e.button === 1) {
                        Helper.openInNewBrowserTab(url);
                    }
                }
            }
        }
    }

    private createSheet = (url: string) => {
        let sheet = General.Sheet.Manager.createSheetWithUrl(url);
        sheet.bind(SheetEventType.Close, () => {
            General.Functions.HistoryState.replaceState("ReportMetaData/SearchReport");
            this.loadData();
        });
        sheet.bind(SheetEventType.Custom, (data) => {
            switch (data.cmd) {
                case "cloneReport":
                    this.createSheet(data.url);
                    break;
            }
        });
    }

    render() {
        const grid = Helper.hasValue(this.translations) ? this.createGrid() : null;
        const search = Helper.hasValue(this.translations) ? this.createSearchFilter() : null;
        return (
            <>
                {search}
                {grid}
            </>
        );
    }
}

interface SearchGridState extends SearchFilter{
    gridData: SearchGridData[]
}

interface SearchGridData {
    Id: number;
    Name: string;
    TargetEntityTypeName: string;
    TargetEntityType: TargetEntityType;
    State: number;
    IsDraft: boolean;
}

interface SearchFilter {
    Name: string;
    TargetEntityType: TargetEntityType;
    SearchMode: SearchMode[]
}

enum SearchMode
{
    //All = 0,
    Draft = 1,
    Active = 2,
    Deactivated = 3
}
